<template>
  <div class="download">
    <img class="download-bg" src="../../public/download_new_bg.png" />
    <div class="flex-bottom">
      <div class="mini-we-chat">
        <img class="scan-code" src="../../public/scan_code.png" />
        <img class="scan-text" src="../../public/scan_text.png" />
      </div>
      <div class="download-content" :class="{ 'ios-m': isIOS() }">
        <div class="download-block download-ios" @click="download">下载Android版</div>
        <div class="download-block download-andriod" @click="download">下载Iphone版</div>
      </div>
    </div>

    <div class="open-browser" v-if="showOpenBrowser" @click="closeOpenBrowser"></div>
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
onMounted(() => {
  setTimeout(() => {
    document.querySelector('.download').scrollTop = 1
  }, 0)
})
function is_weixn() {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}
function isIOS() {
  return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
}
const downloadios = () => {
  if (is_weixn()) {
    showOpenBrowser.value = true
    return
  }
  window.location.href = 'https://apps.apple.com/cn/app/id1597679634'
}
const downloadandroid = () => {
  if (is_weixn()) {
    showOpenBrowser.value = true
    return
  }
  window.location.href =
    'https://zeekrgo-cdn.zeekrlife.com/app/release/zeekr-subscription-release-latest.apk'
}
const download = () => {
  if (isIOS()) {
    downloadios()
  } else {
    downloadandroid()
  }
}
const showOpenBrowser = ref(false)
const closeOpenBrowser = () => {
  showOpenBrowser.value = false
}
</script>
<style scoped>
.download {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #171b21;
  position: relative;
}
.download-bg {
  width: 100%;
}
.download-block {
}
.download-andriod {
  left: auto;
  right: 90px;
}
.open-browser {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8) url(../../public/open-browser.png) 350px 30px / 250px no-repeat;
}
.flex-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 80px;
}
.mini-we-chat {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.scan-code {
  width: 210px;
}
.scan-text {
  margin-top: 32px;
  width: 210px;
}
.download-content {
  color: white;
  display: flex;
  align-items: center;
  padding: 96px 48px 0px 48px;
  justify-content: space-between;
}
.download-block {
  width: 300px;
  height: 80px;
  justify-content: center;
  align-items: center;
  border: 1px solid white;
  line-height: 80px;
  text-align: center;
  font-size: 30px;
}
.ios-m{
  margin-bottom: 100px;
}
</style>
